
import React from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { ArrowRight } from "lucide-react";

const FinalCTA = () => {
  const { language } = useLanguage();
  
  const content = {
    fr: {
      title: "Un cadeau qui grandit avec eux. Pour toujours.",
      subtitle: "Commencez à offrir dès aujourd'hui pour ceux que vous aimez.",
      button: "Créer leur cagnotte cadeau"
    },
    en: {
      title: "Give a Gift That Grows With Them. Forever.",
      subtitle: "Start gifting today for the ones you love.",
      button: "Create a Gift Account"
    },
    de: {
      title: "Ein Geschenk, das mit ihnen wächst. Für immer.",
      subtitle: "Beginnen Sie noch heute mit dem Schenken für Ihre Liebsten.",
      button: "Geschenkkonto erstellen"
    }
  };
  
  const textContent = content[language];

  return (
    <section className="py-20 px-4 bg-gradient-to-r from-future/20 to-sunrise/20">
      <div className="container mx-auto max-w-4xl text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-legatia-green">
          {textContent.title}
        </h2>
        
        <p className="text-xl text-gray-700 mb-10">
          {textContent.subtitle}
        </p>
        
        <Button 
          className="bg-gradient-to-r from-legatia-orange to-legatia-red hover:from-legatia-orange/90 hover:to-legatia-red/90 text-white text-lg px-10 py-7 rounded-full transition-all transform hover:shadow-lg hover:-translate-y-0.5 flex items-center gap-2 mx-auto"
          onClick={() => window.location.href = "https://app.getlegatia.ch/"}
        >
          {textContent.button}
          <ArrowRight className="h-5 w-5" />
        </Button>
      </div>
    </section>
  );
};

export default FinalCTA;
